import { MutationHookOptions, TypedDocumentNode, gql } from "@apollo/client";

import {
  CreateAlertMutation,
  CreateAlertMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { usePerformMutation } from "src/graphql/utils";

export const createAlertMutation = gql`
  mutation CreateAlert($caseId: ID!) {
    createAlert(caseId: $caseId) {
      id
    }
  }
` as TypedDocumentNode<CreateAlertMutation, CreateAlertMutationVariables>;

export const useCreateAlertMutation = (
  options?: MutationHookOptions<CreateAlertMutation, CreateAlertMutationVariables>
) => usePerformMutation(createAlertMutation, { mutationOption: options });
